import { ListItemButton, ListItemText } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"

export function VariantPickerItem({ item: variant }) {
    const { onPickVariant } = useBoundContext()

    return (
        <ListItemButton onClick={handleClick}>
            <ListItemText primary={variant.name} secondary={variant.rateCardName} />
        </ListItemButton>
    )

    function handleClick() {
        onPickVariant(variant)
    }
}
